import { Component, OnInit } from '@angular/core';
import { Requirement } from '../requirement';
import { QuotationService } from '../quotation.service';
import { QuotationListPipe } from '../../pipe/quotation.pipe';
import { ActivatedRoute, Params } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-quotation-list',
  templateUrl: './quotation-list.component.html',
  styleUrls: ['./quotation-list.component.css']
})
export class QuotationListComponent implements OnInit {

  closeResult: string; 
  page=1;
  SerchText:string ='';
    
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  quotation = new Requirement();  //Po is defined from abobe import po
  quotations: Requirement[];
  submitted = false;
  message: string;	
  requester: any [];

  quotationFilter: any = { requirementid: '' };
  totalrecord:number;

  constructor(private quotationService: QuotationService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location,
    private modalService: NgbModal
    ) { }


  ngOnInit(): void {
    this.getRequirements();

  }



  getRequirements() {
    this.spinnerService.show();    
    return this.quotationService.getRequirements()
               .subscribe(
                quotations => {              
                  this.quotations = quotations
                  this.spinnerService.hide();
                  this.totalrecord = this.quotations.length;
                  
                 }
                );
 }


 

delete(requirementid): void {
  //this.submitted = true;
  this.quotationService.deleteRequirement(requirementid)
      .subscribe(()=> this.message = "Requirement Deleted Successfully!");
      this.getRequirements();
}


  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

}
